import { render, staticRenderFns } from "./AddListToQuoteFooter.vue?vue&type=template&id=9cc92930&scoped=true&"
import script from "./AddListToQuoteFooter.vue?vue&type=script&lang=ts&"
export * from "./AddListToQuoteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AddListToQuoteFooter.vue?vue&type=style&index=0&id=9cc92930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc92930",
  null
  
)

export default component.exports